var map = {
	"./alitas.jpeg": "5160",
	"./alitas_2.jpeg": "eed2",
	"./arepa.jpeg": "8c83",
	"./bacon_cheddar.jpeg": "c395",
	"./bacon_premium.jpeg": "16e0",
	"./bowl_western.jpeg": "ff13",
	"./burritos.jpeg": "fba5",
	"./doble.jpeg": "c52e",
	"./especial_premium.jpeg": "951f",
	"./garage_burger.jpeg": "7922",
	"./garage_burger_2.jpeg": "2bed",
	"./hamburguesas_all.jpeg": "18f9",
	"./hotdog_chili.jpeg": "4584",
	"./hotdog_jumbo_especial.jpeg": "197b",
	"./logo.jpg": "bc50",
	"./nachos_no_go.jpeg": "e2ce",
	"./salchipapas.jpeg": "1dfd",
	"./salchipapas_2.jpeg": "e1a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6292";